import type { ConfigProviderProps } from 'antd/es/config-provider';

const menuConfig: ConfigProviderProps['menu'] = {
  expandIcon: ({ isOpen }) => <i className={`fb-icon fb-icon--arrow-${isOpen ? 'up' : 'down'}`} />,
};

export default menuConfig;
